import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLocale } from '../i18n/LocaleContext';
import AppHeader from '../components/AppHeader';
import content, { LAST_UPDATED, OPERATOR, UPDATED_LABEL } from '../legal/content';
import { useDocumentTitle } from '../utils/useDocumentTitle';

const TOKEN = /(\{name\}|\{email\}|\{privacy\})/;

// Swaps the {name}/{email}/{privacy} tokens in legal copy for real content.
function RichText({ text, privacyLabel }) {
  return text.split(TOKEN).map((part, index) => {
    if (part === '{name}') {
      return <React.Fragment key={index}>{OPERATOR.name}</React.Fragment>;
    }
    if (part === '{email}') {
      return (
        <a key={index} className="legal__link" href={`mailto:${OPERATOR.email}`}>
          {OPERATOR.email}
        </a>
      );
    }
    if (part === '{privacy}') {
      return (
        <Link key={index} className="legal__link" to="/privacy">
          {privacyLabel}
        </Link>
      );
    }
    return part;
  });
}

// Renders /privacy and /contact from legal/content.js.
export default function LegalPage({ page }) {
  const { locale, t } = useLocale();
  const doc = content[locale][page];

  useDocumentTitle(`${doc.title} · ${t('app.name')}`);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [page]);

  const privacyLabel = t('legal.privacy');

  return (
    <div className="app">
      <AppHeader />

      <main className="page legal">
        <article className="legal__body">
          <h1 className="legal__title">{doc.title}</h1>
          {page === 'privacy' && (
            <p className="legal__updated">
              {UPDATED_LABEL[locale]} {LAST_UPDATED}
            </p>
          )}
          <p className="legal__intro">{doc.intro}</p>

          {doc.blocks.map((block, index) => (
            <section
              key={index}
              className={block.heading ? 'legal__section' : 'legal__section legal__section--cont'}
            >
              {block.heading && <h2 className="legal__heading">{block.heading}</h2>}
              {block.paragraphs?.map((text, i) => (
                <p key={i}>
                  <RichText text={text} privacyLabel={privacyLabel} />
                </p>
              ))}
              {block.list && (
                <ul className="legal__list">
                  {block.list.map((text, i) => (
                    <li key={i}>
                      <RichText text={text} privacyLabel={privacyLabel} />
                    </li>
                  ))}
                </ul>
              )}
            </section>
          ))}
        </article>
      </main>
    </div>
  );
}
